"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WirelessCartState = /** @class */ (function () {
    function WirelessCartState() {
        this.showPlanDetailsModal = false;
    }
    return WirelessCartState;
}());
exports.default = WirelessCartState;
//# sourceMappingURL=WirelessCartPlanState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessCartPlan/WirelessCartPlanState.js
// module id = 2284
// module chunks = 8